<h3 class="pt-12 pb-4">{{ 'audit' | customerTerm }} Questions</h3>
<div cdkDropList [cdkDropListData]="audit.Questions" (cdkDropListDropped)="drop($event)" >
  @for(q of audit.Questions;track q){
    @if (q.Active == true) {
      <div  cdkDrag #dragRef="cdkDrag" [cdkDragDisabled]="isEditingMode">
        <app-edit-question-selections [newAudit]="newAudit" (updateEditMode)="updateEditMode($event)" [groupEditOn]="isEditingMode" [Question]="q" (questionChange)="auditChanged()" [answerTypes]="questionTypes"
          (deleteQuestion)="deleteQuestion($event)"
        (duplicateQuestion)="duplicateQuestion($event)"></app-edit-question-selections>
      </div>
    }
  }
</div>

<button (click)="addQuestion()" class="btn-primary">Add Question</button>
